export default {"src":"/_next/static/media/user-friendly-interfaces.242b4484.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};